import { useQuery } from '@tanstack/react-query';
import { subscriptionPlanService } from '@services/subscription-plan';
import { SubscriptionPlanTemplate } from '@models/subscription';

export const useSubscriptionPlans = () => {
  return useQuery<SubscriptionPlanTemplate[]>({
    queryKey: ['subscriptionPlans'],
    queryFn: async () => {
      const response = await subscriptionPlanService.getAll();
      return response;
    },
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
    retry: 1,
  });
};
